import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import { DateTime } from 'luxon';
import { DatePicker as MuiDatePicker } from '@material-ui/pickers';
import { defaultTheme, makeStyles } from "../../../styles/index";
import { ChevronLeft, ChevronRight } from "../../../icons/index";
import { useTranslation } from "../../../hooks/useTranslation";
import { Button } from "../../Button/Button";
import { Divider } from "../../Divider/Divider";
import { Grid } from "../../Grid/Grid";
import { Popup } from "../../Popup/Popup";
import { PopupContainer } from "../../Popup/PopupContainer";
import { TextField } from "../../TextField/TextField";
import { PickerConfigProvider } from "./PickerConfigProvider";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        display: 'flex',
    },
    date: {
        flex: '1 0 0',
        minWidth: 0,
    },
    chevronIcon: {
        width: 48,
        margin: -12,
    },
    actions: {
        padding: theme.spacing(1),
    },
    actionButton: {
        padding: 0,
        minWidth: 0,
        width: 64,
    },
}); }, { name: 'SnDatePickerField' });
/**
 * 日付選択フィールド。
 */
export var DatePickerField = function (props) {
    var _a;
    var className = props.className, style = props.style, value = props.value, minDate = props.minDate, maxDate = props.maxDate, disableFuture = props.disableFuture, disablePast = props.disablePast, onChange = props.onChange, _b = props.clearable, clearable = _b === void 0 ? true : _b, disabled = props.disabled;
    var _c = useState(null), anchorRef = _c[0], setAnchorRef = _c[1];
    var _d = useState(false), isOpen = _d[0], setIsOpen = _d[1];
    var handleOpen = useCallback(function () { return setIsOpen(true); }, []);
    var handleClose = useCallback(function () { return setIsOpen(false); }, []);
    var handleChange = useCallback(function (date) {
        onChange === null || onChange === void 0 ? void 0 : onChange(date);
        setIsOpen(false);
    }, [onChange]);
    var handleOk = useCallback(function () {
        // @material-ui/pickersで実装されたOKボタンと挙動を揃える。
        // 未選択状態の場合、UI上ではデフォルト値として今日が選択されており、そのままOKボタンを押すとその日付がセットする。
        // autoOkをtrueにしている限り、日付をユーザーが選択すると自動で確定されるため、その他のケースについては単に閉じるだけで良い。
        if (value == null)
            onChange === null || onChange === void 0 ? void 0 : onChange(DateTime.local().startOf('day'));
        setIsOpen(false);
    }, [onChange, value]);
    var handleClear = useCallback(function () {
        onChange === null || onChange === void 0 ? void 0 : onChange(null);
        setIsOpen(false);
    }, [onChange]);
    var t = useTranslation().t;
    var classes = useStyles(props);
    return (React.createElement(PopupContainer, { className: classNames(classes.root, className), style: style },
        React.createElement("div", { className: classes.date, ref: setAnchorRef },
            React.createElement(TextField, { readonly: true, dense: true, disabled: disabled, placeholder: t('日付'), value: (_a = value === null || value === void 0 ? void 0 : value.toFormat(t('yyyy/MM/dd'))) !== null && _a !== void 0 ? _a : '', onClick: handleOpen })),
        React.createElement(Popup, { open: isOpen && !disabled, anchorEl: anchorRef, onClickAway: handleClose, portal: true, boundariesElement: "viewport" },
            React.createElement(PickerConfigProvider, null,
                React.createElement(MuiDatePicker, { disabled: disabled, variant: "static", disableToolbar: true, disableFuture: disableFuture, disablePast: disablePast, minDate: minDate, maxDate: maxDate, value: value, onChange: handleChange, autoOk: true, leftArrowIcon: React.createElement(ChevronLeft, { className: classes.chevronIcon, color: defaultTheme.palette.text.primary }), rightArrowIcon: React.createElement(ChevronRight, { className: classes.chevronIcon, color: defaultTheme.palette.text.primary }) })),
            clearable && (React.createElement(React.Fragment, null,
                React.createElement(Divider, { thin: true }),
                React.createElement(Grid, { container: true, className: classes.actions, alignItems: "center", justify: "space-between" },
                    React.createElement(Button, { variant: "text", className: classes.actionButton, onClick: handleClear }, "\u30AF\u30EA\u30A2"),
                    React.createElement(Button, { variant: "square", fill: true, className: classes.actionButton, onClick: handleOk }, "OK")))))));
};
